import { AppBrowserModule } from './app/app.browser.module';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';

import { defineCustomElements, applyPolyfills } from '@vestiaire/wc-notification/loader';

if (environment.production) {
  enableProdMode();

  // Little hack to hide console log statements on production build
  // Please note that this trick could also be used to output logs to an
  // external service.
  if (window) {
    window.console.log = function() {};
  }
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    platformBrowserDynamic()
      .bootstrapModule(AppBrowserModule)
      .then(ref => {
        // Ensure Angular destroys itself on hot reloads.
        if (window['ngRef']) {
          window['ngRef'].destroy();
        }
        window['ngRef'] = ref;

        // Otherise, log the boot error
      })
      .catch(err => console.error(err));
  },
  { passive: true }
);

// Keep trailing /
import { Location } from '@angular/common';
Location.stripTrailingSlash = url => url;
applyPolyfills().then(() => {
  defineCustomElements(window);
});
defineCustomElements(window);
